  document.addEventListener("DOMContentLoaded", function () {
var swiper = new Swiper(".instagram-feed-swiper", {
   loop: true,
    slidesPerView: "auto",
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
      pauseOnMouseEnter: true
    },
    navigation: {
      prevEl: ".swiper-button-prev",
      nextEl: ".swiper-button-next"
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true
    },
    breakpoints: {
      1024: { slidesPerView: 4, },
      768: { slidesPerView: 2, spaceBetween: 10, },
      500: { slidesPerView: 1,spaceBetween: 10, }
    }
});

  });
